import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadFranchisees } from './actions';
import authUtils from '../../auth/utils';
import Filter from './Filter';
import List from './List';

class Franchisees extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageNumber, pageSize});
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	render() {
		const { allowNew } = this.props;

		return (
			<div>

				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} loading={this.props.pagination.loading}/>
				<List onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination} allowNew={allowNew}/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { franchisees },
		auth: { currentUser }
	} = state;

	const franchiseesPagination = pagination.franchisees.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: franchiseesPagination.ids.map(id => franchisees[id]),
		pagination: franchiseesPagination,
		allowNew: authUtils.hasPermission(currentUser, 'AddFranchisee') && !authUtils.hasReadOnlyPermission(currentUser, 'Franchisees') &&
			!currentUser.isFranchiseeRestricted && !currentUser.isCenterRestricted,
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadFranchisees,
	initializeFilter: (data, fields) => initialize('franchiseesFilter', data, fields)
})(Franchisees);